// @flow
import { useSelector } from 'react-redux';
import { INSIGHT_GENERAL_OVERVIEW } from './InsightRouteConstants';
import { Navigate } from 'react-router';
import { isDefined } from 'util/ObjectUtils';
import { isAdministrator, isInsightUser, isUserAuthenticated } from '../../store/selector/UserSelector';
import InsightNavigationBar from '../../insight/components/navigation/InsightNavigationBar';
import { LOGIN } from '../../common/routing/RouteConstants';

type Props = {
  restricted?: boolean, // if set to true than only Administrators can access this route
  internalRestricted?: boolean, // if set to true only Internal roles can access this route
  children: React$Node
};

const PrivateRoute = (props: Props): React$Node => {
  const authenticated = useSelector(isUserAuthenticated);
  const administrator = useSelector(isAdministrator);
  const isInsight = useSelector(isInsightUser);
  const { restricted = false, internalRestricted = false, children } = props;

  let enableRoute = restricted ? administrator : authenticated;
  if (enableRoute) {
    enableRoute = internalRestricted ? isInsight : true;
  }

  let navigateTo = null;
  if (authenticated) {
    if (!enableRoute) {
      navigateTo = INSIGHT_GENERAL_OVERVIEW;
    }
  } else {
    navigateTo = LOGIN;
  }

  return isDefined(navigateTo) ? (
    <Navigate to={navigateTo} replace />
  ) : (
    <InsightNavigationBar>{children}</InsightNavigationBar>
  );
};

export default PrivateRoute;
